import React, { useContext } from 'react'
import {
    Stack,
    Box,
    Typography,
} from '@mui/material'

// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';
// import SplitText from 'gsap/SplitText';

import { ThemeContext } from '../../context/theme/context.js'
import Header from './../../utils/header.js'
import data from '../../data/about.json'
import useCursorHandlers from '../../hooks/cursor_handlers.js'

const About = () => {
    const { state } = useContext(ThemeContext)
    const cursorHandlers = useCursorHandlers()

    // useEffect(() => {
    //     gsap.config({ trialWarn: false });
    //     gsap.registerPlugin(ScrollTrigger, SplitText);

    //     // Create split text instance
    //     const split = new SplitText(".text", { type: "lines" });

    //     // Create animation for each line
    //     split.lines.forEach((target) => {
    //         gsap.fromTo(target, 
    //             {
    //                 opacity: 0,
    //                 y: 50
    //             },
    //             {
    //                 opacity: 1,
    //                 y: 0,
    //                 duration: 1,
    //                 ease: "power2.out",
    //                 scrollTrigger: {
    //                     trigger: target,
    //                     start: "top 80%",
    //                     end: "bottom 20%",
    //                     toggleActions: "play none none reverse",
    //                     // markers: true, // Uncomment for debugging
    //                 }
    //             }
    //         );
    //     });

    //     // Cleanup function
    //     return () => {
    //         split.revert();
    //         ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    //     };
    // }, []); // Empty dependency array means this runs once on mount

    return <Box>
        <Header
            color={state.color.primary}
            title='ABOUT ME' />
        <Stack
            direction={{ xs: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            alignItems="center"
            {...cursorHandlers} >
            <div className={"text"}>
                <Typography
                    lineHeight={1.3}
                    fontFamily='"Noto Sans", sans-serif'
                    color={state.color.primary}
                    fontSize={{ xs: 14, md: 24 }}
                >
                    {data.data}
                </Typography>
            </div>
        </Stack >
    </Box >
}

export default About